import { tasks } from '../task'
import { describeTable } from './describeTable'

describeTable(tasks, {
  description: `A staff to-do item (tehtävä) assigned to one user, optionally attached to a CRM entity via entity_type + entity_id (mostly 'opportunity' and 'customer'; also 'employee' for bad-feedback follow-ups). Written by hand in the ERP and by automations: a follow-up task when a lead is contacted or an offer is sent ('offer-<id>-followup'), an e-invoice billing task per completed visit of an einvoice customer ('einvoice_billing_visit_<id>'), and similar. deduplication_key identifies the automation and prevents duplicates — use it (prefix match) to tell automated tasks from manual ones.
Open = completed_at IS NULL; overdue = open AND deadline < now(). Automatic sales follow-up tasks are commonly postponed a day at a time, so deadline edits are frequent and updated_at is noisy. This is a work-queue table, not an activity log — activities holds what actually happened on a lead.`,
  columns: {
    title: 'Short text of the to-do.',
    deadline:
      'When it should be done; the basis of the overdue and next_action_at logic.',
    completedAt: 'When it was ticked off; NULL = open.',
    assignedUserId: 'Staff member responsible.',
    createdByUserId: 'Who created it; the system user for automated tasks.',
    entityType:
      "Type of the attached record: 'opportunity', 'customer', 'employee' …; NULL = free-standing task.",
    entityId: 'Id in the table named by entity_type.',
    deduplicationKey:
      "Automation key, e.g. 'einvoice_billing_visit_123', 'offer-45-followup'. NULL for manual tasks. Unique among live rows.",
    metadata: 'Automation payload JSON, e.g. { visitId } on billing tasks.',
  },
})
